import '@loyal_template/showcases.css'

import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import ShowcasePlaceholder from 'Catalog/Showcase/ShowcasePlaceholder'
import ShowcaseHeader from 'Catalog/Showcase/ShowcaseHeader'
import ShowcaseProductListWrapper from 'Catalog/Showcase/ShowcaseProductListWrapper'

const Showcase = ({
  children,
  isLoading,
  products,
  title,
  titleOnlyCash,
  mobileTitle,
  id,
  showcaseType,
  identifier,
  catalogId,
  viewAllPath,
  desktopItemsQty
}) =>
  isLoading || id ? (
    <ShowcasePlaceholder isLoading={isLoading && products.length === 0}>
      <div className='showcard-products container-card container py-1 py-md-3 px-0 px-md-0'>
        <ShowcaseHeader
          title={process.env.REACT_APP_TITLE_SHOWCASE_DEFAULTS || title}
          titleOnlyCash={titleOnlyCash}
          mobileTitle={mobileTitle}
          viewAllPath={viewAllPath || getUrlViewAllShowcaseHome(catalogId)}
        />
        <ShowcaseProductListWrapper desktopItemsQty={desktopItemsQty} viewAllPath={viewAllPath || `/search`}>
          {children}
        </ShowcaseProductListWrapper>
      </div>
    </ShowcasePlaceholder>
  ) : null

Showcase.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  titleOnlyCash: PropTypes.string,
  mobileTitle: PropTypes.string,
  isLoading: PropTypes.bool,
  products: PropTypes.array,
  children: PropTypes.any.isRequired,
  showcaseType: PropTypes.number,
  identifier: PropTypes.string,
  catalogId: PropTypes.string,
  viewAllPath: PropTypes.string,
  desktopItemsQty: PropTypes.number
}

function getUrlViewAllShowcaseHome (catalogId) {
  var result = `/search`
  if (process.env.REACT_APP_SHOWCASE_HOME_VIEWALL_URL) {
    var catalogViewAllUrls = process.env.REACT_APP_SHOWCASE_HOME_VIEWALL_URL.split('|')
    var i = 0
    var value = catalogId
    for (i = 0; i < catalogViewAllUrls.length; i++) {
      if (catalogViewAllUrls[i].split(',')[0] === value) {
        result = catalogViewAllUrls[i].split(',')[1]
      }
    }
    if (catalogViewAllUrls.length <= 0) {
      if (process.env.REACT_APP_SHOWCASE_HOME_VIEWALL_URL.split(',')[0] === value) {
        result = process.env.REACT_APP_SHOWCASE_HOME_VIEWALL_URL.split(',')[1]
      }
    }
  }
  return result
}

const mapStateToProps = ({
  oidc: {
    user: { profile }
  }
}) => ({
  catalogId: profile['custom:catalog_id']
})

const mapDispatchToProps = dispatch => ({
  redirect: path => dispatch(push(path))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Showcase)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/Showcase.js